import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validate } from "components/DynamicForm/validate";
import DynamicForm from "components/DynamicForm";
import FormButton from "components/FormButton";
import RecursiveDataPreview from "components/RecursiveDataPreview";
import {
  clearRecursiveFormData,
  clearSaveData,
  clearShowData,
  setFormFields,
} from "redux/recursiveReducer";
import { Label } from "lib";
import { dynamicFormScroll, dynamicFormScrollBottom } from "utils";
import {
  clearRecursiveFormDataKey,
  setAddShowData,
  setEditIndex,
  setEditSaveData,
  setEditShowData,
  setIsEditRecursiveForm,
  setRecursiveFormData,
  setSaveData,
  setShowAddMore,
  setShowData,
  setShowDataPreview,
  setShowRecursiveForm,
  setMaxLength,
  setMinLength,
  setIsMinor,
  setIsAssociatedDisabled,
  setAddSaveData,
  setArrayName,
  setSignerParams
} from "redux/recursiveReducer";
import {
  setAssociatedWf,
  setIsMinorDisabled,
  setIsAssociatedWfDisabled,
  setAssociatedWfAge,
  setAssociateRequired,
  setCurrentFormType,
  cleardeleteRecursiveDocument
} from "redux/recursiveReducer";
import { setSelectedData as setSelectedFormData } from "redux/formDisplay";
// import { setAssociateRequired , setCurrentFormType } from 'redux/recursiveReducer';

import "./index.scss";
import { clearValidateTriggered } from "redux/formDisplay";
import { setdeleteDocument } from "redux/uploadDocumentReducer";
import { Row } from "react-bootstrap";
import { setSubworkFlowInfo } from "redux/dashBoardDetailReducer";

const Recursive = (props) => {
  const {
    recursiveRead,
    recursiveTrigger,
    recursiveName,
    dataPreview,
    setSelectedData,
    selectedData,
    inputFields,
    recursiveActions,
    handleNext,
    handleAdd,
    handleCancel,
    recursiveTitle,
    handleBack,
    formErr,
    setFormErr,
    clearFieldError,
    minLength,
    maxLength,
    SignerRecursion,
    triggerEsignRequest,
    signaturePosition,
    signer_validation_name,
    customStyle
  } = props;

  const dispatch = useDispatch();

  const recursive = useSelector((state) => state.recursive);
  const formData = useSelector((state) => state.formData);
  const saveData = useSelector((state) => state.recursive.saveData);
  const showData = useSelector((state) => state.recursive.showData);
  const formFields = useSelector((state) => state.recursive.formFields);
  const staticData = useSelector((state) => state?.staticData);
  const recursiveFormData = useSelector(
    (state) => state.recursive?.recursiveFormData
  );
  const isEditRecursiveForm = useSelector(
    (state) => state.recursive?.isEditRecursiveForm
  );
  const deleteRecursiveDocument = useSelector((state)=> state.recursive?.deleteRecursiveDocument)
  const showRecursiveForm = useSelector(
    (state) => state.recursive.showRecursiveForm
  );
  const associatedWf = useSelector((state) => state.recursive.associatedWf);
  const isMinor = useSelector((state) => state.recursive.isMinor);
  const associatedWfAge = useSelector(
    (state) => state.recursive.associatedWfAge
  );
  const isEditMinor = useSelector((state) => state.recursive.isEditMinor);
  const isAssociatedDisabled = useSelector(
    (state) => state.recursive.isAssociatedDisabled
  );
  const editIndex = useSelector((state) => state.recursive.editIndex);
  //rework
  const associateRequired = useSelector(
    (state) => state?.recursive?.associateRequired
  );
  const currentFormType = useSelector(
    (state) => state?.recursive?.currentFormType
  );
  const isSignerRecursion = useSelector(
    (state) => state.recursive?.isSignerRecursion
  );
  const showDataPreview = useSelector(
    (state) => state?.recursive?.showDataPreview
  );
  const selectedFormData = useSelector((state) => state.formData?.selectedData);
  let complete_selectedData = useSelector((state) => state.formData?.selectedData);
  const subworkFlowInfo = useSelector((state)=> state?.dashboardDetailReducer?.userSubworkFlowInfo)
  // console.log("🚀 ~ file: index.js:43 ~ CommonTabs ~ dashboardDetailReducer:", dashboardDetailReducer?.dashboardDetailData)
  //Mobile Responsivess state
  const [isMobile, setIsMobile] = useState(false);

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };

  useEffect(() => {
    if (recursiveTrigger) {
      if (selectedData?.majority == "Minor" && selectedData?.birth_date) {
        if (
          currentFormType === "applicant" &&
          !(editIndex + 1 < saveData.length)
        ) {
          dispatch(setAssociateRequired(true));
        }
      } else if (
        (selectedData?.majority == "Major" && selectedData?.birth_date) ||
        (selectedData?.majority == "Senior" && selectedData?.birth_date)
      ) {
        if (currentFormType === "applicant") {
          if (!showDataPreview) {
            dispatch(setAssociateRequired(false));
          }
        } else {
          dispatch(setAssociateRequired(false));
        }
      }
    }
  }, [selectedData?.birth_date, isEditRecursiveForm]);

  const handleAddMore = () => {
    //* change currFrom type here
    if (recursiveTrigger) {
      if (associateRequired === true) {
        dispatch(setCurrentFormType("associate"));
      } else {
        dispatch(setCurrentFormType("applicant"));
      }
    }
    //Removing the previously filled data to get a clean form (moved code to handleAdd)
    let recursiveNameFields = [];
    formFields.map((item) => {
      return recursiveNameFields.push({ name: item.name, label: item.label });
    });
    if(SignerRecursion == true ){ 
      dispatch(clearRecursiveFormDataKey({ key: 'trigger_esign_request' }))
      dispatch(clearRecursiveFormDataKey({ key: 'signature_position' }))
      dispatch(clearRecursiveFormDataKey({ key: 'co_signer' }))
      dispatch(clearRecursiveFormDataKey({ key: 'signer_validation_name' }))
    }
    if(recursiveFormData?.hasOwnProperty('verification_response')){
      dispatch(clearRecursiveFormDataKey({ key: 'verification_response' })) 
    }
    recursiveNameFields.map((item) => {
      dispatch(clearRecursiveFormDataKey({ key: item.name }));
    });
    dispatch(clearValidateTriggered());
    dispatch(setShowRecursiveForm(true));
    dispatch(setShowAddMore(false));
    dynamicFormScrollBottom();
  };

  const handleEditChange = (index) => {
    Object.entries(saveData[index]).map((item) => {
      dispatch(setRecursiveFormData({ key: item[0], value: item[1] }));
    });
    dispatch(setEditIndex(index));
    dispatch(setShowAddMore(false));
    dispatch(setIsEditRecursiveForm(true));
    dispatch(setShowRecursiveForm(true));
    dispatch(clearValidateTriggered()); // To clear the validation error when the user clicks on back button or page refresh or next button
    setFormErr({}); 
    dynamicFormScrollBottom();
  };

  //* called on click of update button
  const handleEdit = async() => {
    if(complete_selectedData && Object.entries(complete_selectedData)?.length == 0 && Object.entries(subworkFlowInfo)?.length > 0){
      complete_selectedData = subworkFlowInfo?.source_data
    }
    let validateFields = [];
    inputFields.map((_item) => {
      // let selectToggleFields = false;
      // if (_item.type == "toggle") {
      //   selectToggleFields = true;
      // }
      if (
        // selectToggleFields &&
        _item.hasOwnProperty("show") &&
        IndirectEval(_item.show)
        ) {
        validateFields = [...validateFields, _item];
      }
      // if (!selectToggleFields) {
      //   let selectDependentFields = false;
      //   if (_item.hasOwnProperty("show")) {
      //     selectDependentFields = IndirectEval(_item.show);
      //   }
      //   if (selectDependentFields) validateFields = [...validateFields, _item];
      // }
    });
    let errors;
    errors = await validate(validateFields, recursiveFormData, dispatch,staticData, null,recursive,complete_selectedData);
    // console.log(errors);
    let errKeys = Object.keys(errors);
    if (errKeys?.length !== 0) {
      setFormErr(errors);
      dynamicFormScroll();
      return;
    }
    let editRecursiveData = {},
      mobile,
      countryCode,
      completeMobileNumber;
    countryCode = recursiveFormData.country_code;
    // dispatch(setEditSaveData());
    formFields.map((item) => {
      if (recursiveFormData[item.name] && IndirectEval(item?.show)) {
        editRecursiveData[item.name] = recursiveFormData[item.name];
      }
      if(recursiveFormData?.hasOwnProperty('verification_response')){
        editRecursiveData['verification_response'] = recursiveFormData['verification_response'];
        dispatch(clearRecursiveFormDataKey({ key: 'verification_response' })) 
      }
    });
    if(SignerRecursion == true && signaturePosition && triggerEsignRequest){
      editRecursiveData['signature_position'] = signaturePosition;
      editRecursiveData['trigger_esign_request'] = IndirectEval(triggerEsignRequest);
    }
    if(SignerRecursion == true){
      editRecursiveData['co_signer'] = true
    }
    if(deleteRecursiveDocument){
      deleteRecursiveDocument?.map((ele)=>{
        dispatch(setdeleteDocument({key:'',value:ele}))
      })
      dispatch(cleardeleteRecursiveDocument())
    }
    // // console.log(editRecursiveData);
    if (Object.keys(recursiveFormData).includes("guardian_of")) {
      editRecursiveData["Guardian Of"] = recursiveFormData["guardian_of"];
    }
    
    dispatch(setEditShowData({editIndex : editIndex,data : editRecursiveData}));
    dispatch(setEditSaveData({editIndex : editIndex,data : editRecursiveData}));
    dispatch(setIsEditRecursiveForm(false));
    dispatch(setShowRecursiveForm(false));
    dispatch(setShowAddMore(true));
    dispatch(setIsAssociatedWfDisabled(false));
    dispatch(setEditIndex(-1));
    if (!isEditMinor) {
      dispatch(setAssociatedWf(false));
      dispatch(setIsMinor(false));
    }
    dynamicFormScroll();
  };

  useEffect(() => {
    checkWindowWidth();
    return () => {
      dispatch(clearSaveData())
      dispatch(clearShowData())
      dispatch(setShowDataPreview(false))
    }
  }, []);

  useEffect(() => {
    // // console.log("yes yes yes ");
    dispatch(setMinLength(minLength));
    dispatch(setMaxLength(maxLength));
    // if (saveData.length >= 1) {
    let formattedFormFields = inputFields.filter(
      (item) => item.type != "toggle"
    );
    dispatch(setFormFields(formattedFormFields));
    // }
    // Reseting to default values when all data in saveData is removed
    dispatch(setCurrentFormType("applicant"));
    dispatch(setAssociateRequired(false));
  }, []);

  useEffect(() => {
    dispatch(setIsEditRecursiveForm(false));
    // // console.log(recursiveName);
    dispatch(clearRecursiveFormData()); 
    dispatch(clearShowData());
    dispatch(clearSaveData());
    let formattedFormFields = inputFields.filter(
      (item) => item.type != "toggle"
    );
    dispatch(setFormFields(formattedFormFields));
    dispatch(setArrayName(recursiveName));
    if (formData.selectedData[recursiveName]) {
      if (formData.selectedData[recursiveName] === true) {
        dispatch(setShowRecursiveForm(true))
        return;
      }
      dispatch(setShowDataPreview(true));
      dispatch(setShowRecursiveForm(false));
      formData.selectedData[recursiveName].map((item) => {
        dispatch(setShowData(item));
      });
      // dispatch(setShowData(...formData.selectedData[recursiveName]));
      dispatch(setSaveData(formData.selectedData[recursiveName]));
      // // console.log(inputFields[0].type === "toggle");
      if (inputFields[0].type === "toggle") {
        dispatch(
          setRecursiveFormData({ key: inputFields[0].name, value: true })
        );
      }
    }
    else if(subworkFlowInfo && subworkFlowInfo['source_data'] &&  subworkFlowInfo?.source_data[recursiveName]){
      if (subworkFlowInfo?.source_data[recursiveName] === true) {
        dispatch(setShowRecursiveForm(true))
        return;
      }
      dispatch(setShowDataPreview(true));
      dispatch(setShowRecursiveForm(false));
      subworkFlowInfo?.source_data[recursiveName]?.map((item) => {
        dispatch(setShowData(item));
      });
      dispatch(setSaveData(subworkFlowInfo?.source_data[recursiveName]));
      if (inputFields[0].type === "toggle") {
        dispatch(
          setRecursiveFormData({ key: inputFields[0].name, value: true })
        );
      }
    }
    if(SignerRecursion == true && signaturePosition && triggerEsignRequest){
      dispatch(setSignerParams({key : "signature_position",value :signaturePosition}))
      dispatch(setSignerParams({key : "trigger_esign_request",value :triggerEsignRequest}))
      if(signer_validation_name){
        dispatch(setSignerParams({key : "signer_validation_name",value :signer_validation_name}))
      }
    }
    // else {
    //   dispatch(setShowDataPreview(false));
    //   dispatch(setShowRecursiveForm(true));
    // }
  }, [recursiveName]);

  // Mobile Responsivess - conditions - start

  const checkWindowWidth = () => {
    const width = window.innerWidth;
    if (width < 640 && !isMobile) {
      setIsMobile(true);
    } else if (width > 640 && isMobile) {
      setIsMobile(false);
    }
  };

  window.addEventListener("resize", () => checkWindowWidth());

  // Mobile Responsivess - conditions - end

  return (

    <Row className="p-md-3 bg-theme-grey-2 my-lg-0 border rounded mx-0">
         {!dataPreview && (
      <>
        {inputFields &&
          inputFields?.map((item, index) => {
            //Showing the already filled data values
            //* commented by dev_param
            // if (item.type == "toggle") {
            //   let showRecursiveData = {};

            //   if (formData?.selectedData[item.name]) {
            //     dispatch(setShowDataPreview(true));
            //     dispatch(setSaveData(formData?.selectedData[item.name]));
            //     formData?.selectedData[item.name]?.map((el, elIndex) => {
            //       let objEntries = Object.entries(el);
            //       let obj = {};
            //       objEntries.forEach((_el, _elIndex) => {
            //         if (inputFields[_elIndex + 1].name == _el[0]) {
            //           showRecursiveData[inputFields[_elIndex + 1].label] =
            //             _el[1];
            //           return (obj[inputFields[_elIndex + 1].label] =
            //             _el[1]);
            //         }
            //       });
            //       dispatch(setShowData(obj));
            //       return obj;
            //     });
            //   }
            // }
            //Displaying the recursive form
            return (
              <Fragment key={index}>
                <DynamicForm
                  formErr={formErr}
                   setFormErr={setFormErr}// if (item.type == "toggle")
                  //   return (
                  //     <Fragment key={index}>
                  //       <DynamicForm
                  //         formErr={formErr}
                  //         clearFieldError={clearFieldError}
                  //         setSelectedData={setSelectedFormData}
                  //         selectedData={selectedData}
                  //         formButtons={recursiveActions}
                  //         recursiveFormButtons={recursiveActions}
                  //         formFields={item}
                  //       />
                  //     </Fragment>
                  //   );
                  clearFieldError={clearFieldError}
                  setSelectedData={
                    item.type === "toggle"
                      ?  Object.entries(subworkFlowInfo)?.length > 0 ? setSubworkFlowInfo: setSelectedFormData
                      : setSelectedData
                  }
                  selectedData={
                    item.type === "toggle" ? Object.entries(subworkFlowInfo)?.length > 0 ? subworkFlowInfo?.source_data : selectedFormData : selectedData
                  }
                  formButtons={recursiveActions}
                  recursiveFormButtons={recursiveActions}
                  formFields={item}
                  isRecursive={true}

                />
              </Fragment>
            );
          })}
        <FormButton
          formButtons={recursiveActions}
          handleNext={handleNext}
          handleCancel={handleCancel}
          handleBack={handleBack}
          selectedData={selectedData}
          //Using this in validateAndSubmit function
          isRecursive={true}
          minLength={minLength}
          maxLength={maxLength}
          isMobile={isMobile}
        />
      </>
    )}

    {dataPreview && (
      <>
        <>
          <div className="px-2">
            <Label label={recursiveTitle} className={`${customStyle}`} />
          </div>
          <RecursiveDataPreview
            recursiveRead = {recursiveRead}
            recursiveTrigger={recursiveTrigger}
            data={showData}
            handleEditChange={handleEditChange}
          />
          {/* {
                        showRecursiveForm &&
                        inputFields && inputFields?.forEach((item) => {
                            if (item.type == "toggle") {
                                return updateSelectedData(item.name, true)
                            }
                            return
                        })
                    } */}
          {showRecursiveForm &&
            inputFields &&
            inputFields?.map((item, index) => {
              if (item.type == "toggle") return;
              return (
                <Fragment key={index}>
                  <DynamicForm
                    formFields={item}
                    selectedData={recursiveFormData}
                    setSelectedData={setSelectedData}
                    formErr={formErr}
                    clearFieldError={clearFieldError}
                    isRecursive={true}
                    customStyle={customStyle}
                  />
                </Fragment>
              );
            })}
          <FormButton
            formButtons={recursiveActions}
            handleNext={handleNext}
            handleCancel={handleCancel}
            handleBack={handleBack}
            handleEdit={handleEdit}
            handleAddMore={handleAddMore}
            isRecursive={true}
            className="recursive_button"
            minLength={minLength}
            maxLength={maxLength}
            isMobile={isMobile}
          />
        </>
      </>
    )}
    </Row>

  );
};

export default Recursive;
